import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { environment } from '../../../environments/environment';

type RequestOptions = {
  body?: unknown;
  queryStringParameters?: Record<string, string | number | boolean>;
};

export function isCmcApiUrl(url: string): boolean {
  try {
    const api = new URL(environment.apiEndpoint);
    const target = new URL(url, window.location.origin);
    const basePath = api.pathname.endsWith('/') ? api.pathname : `${api.pathname}/`;
    return target.origin === api.origin && target.pathname.startsWith(basePath);
  } catch {
    return false;
  }
}

@Injectable({ providedIn: 'root' })
export class CmcApiService {
  constructor(private readonly http: HttpClient) {}

  get(name: string, path: string, options: RequestOptions = {}): Promise<any> {
    return this.request('GET', name, path, options);
  }

  post(name: string, path: string, options: RequestOptions = {}): Promise<any> {
    return this.request('POST', name, path, options);
  }

  put(name: string, path: string, options: RequestOptions = {}): Promise<any> {
    return this.request('PUT', name, path, options);
  }

  del(name: string, path: string, options: RequestOptions = {}): Promise<any> {
    return this.request('DELETE', name, path, options);
  }

  private request(method: string, name: string, path: string, options: RequestOptions): Promise<any> {
    if (name !== 'route-api') {
      return Promise.reject(new Error(`API CMC inconnue: ${name}`));
    }
    const base = environment.apiEndpoint.endsWith('/') ? environment.apiEndpoint : `${environment.apiEndpoint}/`;
    const target = new URL(path.replace(/^\//, ''), base);
    target.pathname = target.pathname.replace(/\/+$/, '') || '/';
    const url = target.toString();
    if (!isCmcApiUrl(url)) {
      return Promise.reject(new Error('URL hors de l API CMC'));
    }
    const params = new HttpParams({
      fromObject: Object.fromEntries(
        Object.entries(options.queryStringParameters || {}).map(([key, value]) => [key, String(value)]),
      ),
    });
    return firstValueFrom(this.http.request<any>(method, url, { body: options.body, params }));
  }
}